import {map} from "rxjs/operators";
import Api from "../../Api";
import Constants from "../../Constants";
import {RelationshipCreateDto, RelationshipUpdateDto} from "./RelationshipDto";

const RELATIONSHIP_API_BASE_URL: string = Constants.REST_API_URL + "/repository/relationships";

export class RelationshipApiClient {

    createRelationship(relationship: RelationshipCreateDto) : Promise<void> {
        const request = {
            url: `${RELATIONSHIP_API_BASE_URL}/`,
            method: "POST",
            body: relationship,
        };
        return Api.createAjax(request)
                .pipe(
                        map(response => response.response as void)
                )
                .toPromise();
    }

    updateRelationship(relationshipId: string, body: RelationshipUpdateDto): Promise<void> {
        const request = {
            url: `${RELATIONSHIP_API_BASE_URL}/${relationshipId}`,
            method: "PATCH",
            body: body,
        };
        return Api.createAjax(request)
                .pipe(
                        map(response => response.response as void)
                )
                .toPromise();
    }

    deleteRelationship(relationshipId: string): Promise<void> {
        const request = {
            url: `${RELATIONSHIP_API_BASE_URL}/${relationshipId}`,
            method: "DELETE",
        };
        return Api.createAjax(request)
                .pipe(
                        map(response => {})
                )
                .toPromise();
    }

}
